import { BellOff, Check, UserPlus, X } from 'lucide-react';
import { Button } from '../../components/ui/Button.js';
import { cx } from '../../lib/cx.js';

export interface BulkActionBarProps {
  count: number;
  onAck: () => void;
  onClose: () => void;
  onSnooze: () => void;
  onAssign: () => void;
  onClear: () => void;
  pending?: boolean;
  /** Rendered inline (per-group bar) instead of sticky at the bottom. */
  inline?: boolean;
  className?: string;
}

/** Sticky bar that appears once rows are selected. */
export function BulkActionBar({
  count,
  onAck,
  onClose,
  onSnooze,
  onAssign,
  onClear,
  pending,
  inline,
  className,
}: BulkActionBarProps) {
  if (count === 0) return null;
  return (
    <div
      role="region"
      aria-label="Bulk actions"
      className={cx(
        'flex flex-wrap items-center gap-2 rounded-[var(--radius-md)] border border-[var(--border-strong)]',
        'bg-[var(--surface)] px-3 py-2 shadow-[var(--shadow-2)]',
        inline ? '' : 'sticky bottom-3 z-10 vam-enter',
        className,
      )}
    >
      <span className="tnum text-[var(--text-base)] font-medium text-[var(--text)]">
        {count} selected
      </span>
      <div className="flex flex-wrap items-center gap-1.5">
        <Button size="sm" variant="secondary" onClick={onAck} loading={pending}>
          <Check className="h-3.5 w-3.5" />
          Acknowledge
        </Button>
        <Button size="sm" variant="secondary" onClick={onSnooze} loading={pending}>
          <BellOff className="h-3.5 w-3.5" />
          Snooze
        </Button>
        <Button size="sm" variant="secondary" onClick={onAssign} loading={pending}>
          <UserPlus className="h-3.5 w-3.5" />
          Assign
        </Button>
        <Button size="sm" variant="danger" onClick={onClose} loading={pending}>
          <X className="h-3.5 w-3.5" />
          Close
        </Button>
      </div>
      <Button size="sm" variant="ghost" className="ml-auto" onClick={onClear}>
        Clear selection
      </Button>
    </div>
  );
}
